module.exports = __webpack_public_path__ + "static/media/the-dutch_vino.04d7393e.jpg";